export default {"src":"/_next/static/media/chevron-right-white.05852f00.svg","height":14,"width":8};